import React from 'react';
import Localize from 'react-intl-universal';

import { getYear } from 'date-fns';

import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import { styled, useTheme } from '@mui/material/styles';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';

import { routes } from '@navigation/Constants';

import ContactSupport from './ContactSupport';
import FooterLink from './FooterLink';

const StyledAppBar = styled(AppBar, {
  shouldForwardProp: (prop) => prop !== 'disableComponent'
})(({ disableComponent, theme }) => ({
  backgroundColor: theme.footer.backgroundColor,
  fontSize: '1rem',
  pointerEvents: disableComponent ? 'none' : 'auto',
  filter: disableComponent ? 'blur(1.5px)' : 'none',
  position: 'fixed',
  bottom: 0,
  left: 0,
  zIndex: '1000',
  minHeight: '5rem',
  [theme.breakpoints.up('md')]: {
    position: 'inherit',
    minHeight: 'inherit'
  }
}));

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  justifyContent: 'space-between',
  alignItems: 'center',

  [theme.breakpoints.up('md')]: {
    '&.MuiToolbar-root': {
      minHeight: '2.5rem'
    }
  }
}));

const StyledAllRights = styled(Typography)(({ theme }) => ({
  marginLeft: 0,
  color: theme.header.color,
  [theme.breakpoints.up('md')]: {
    marginLeft: '1rem'
  }
}));

const StyledBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.up('md')]: {
    display: 'block'
  }
}));

const StyledCopy = styled(Box)(({ theme }) => ({
  color: theme.header.color,
  display: 'inline',
  '&::after': {
    content: `"${theme?.copyRights}"`,
    display: 'inline',
    paddingLeft: '5px'
  }
}));

const Footer = ({ disableComponent }) => {
  const theme = useTheme();

  return (
    <StyledAppBar
      position='static'
      data-testid={'footerContainer'}
      disableComponent={disableComponent}
    >
      <StyledToolbar>
        <StyledBox>
          <StyledCopy>{`© ${getYear(new Date())}`}</StyledCopy>
          <StyledAllRights display='inline'>{Localize.get('Footer.allRights')}</StyledAllRights>
        </StyledBox>
        <StyledBox sx={{ textAlign: 'end', fontSize: '1rem' }}>
          {theme?.footer?.legalNotice && (
            <FooterLink linkName={theme.footer.legalNotice.key} to={routes.path.legalNotice} />
          )}
          {theme?.footer?.privacyPolicy && (
            <FooterLink linkName={theme.footer.privacyPolicy.key} to={routes.path.privacyPolicy} />
          )}
          <ContactSupport />
        </StyledBox>
      </StyledToolbar>
    </StyledAppBar>
  );
};

export default Footer;
